import * as actionTypes from "./actionTypes";
import find from "lodash/find";
import replace from "lodash/replace";
import {
  welcomeStep,
  CHART_SELECTED_MESSAGE,
  SELECT_CHART_MESSAGE,
  TRIGGER_TYPE_FUNCTION,
  TOOLKIT_SELECTED_STEP,
  toolkitRecommender,
  UPLOAD_PDF_OPTIONS_AFTER_RESPONSE,
} from "../../utils/daniUtils";
import * as url from "./../../utils/url.js";
import axios from "./../../axios";
import {
  chatQuerySearchTypes,
  limitTokenizeText,
  maintainMessagesThreshHold,
  reduceDaniHistoryMessages,
  standardizeSearchQuery,
} from "../../utils/constants";
import { MdOnlinePrediction } from "react-icons/md";

export const openDani = () => {
  // console.log("action called..");
  return {
    type: actionTypes.OPEN_DANI,
    val: null,
  };
};

export const closeDani = () => {
  // console.log("action called..");
  return {
    type: actionTypes.CLOSE_DANI,
    val: null,
  };
};

export const clearSteps = (step) => {
  // console.log("triggering next step.");
  // console.log(nextStep);
  return {
    type: actionTypes.DANI_CLEAR_STEPS,
    val: step,
  };
};

export const closeDaniHelpText = () => {
  return {
    type: actionTypes.CLOSE_DANI_HELP_TEXT,
    val: null,
  };
};

export const triggerNextStep = (step) => {
  const { trigger } = step;
  const nextStep = find(welcomeStep, { id: trigger });
  // console.log("triggering next step.");
  let doc = null;
  if (nextStep) {
    doc = { ...nextStep, timeStamp: new Date() };
  } else {
    doc = nextStep;
  }

  return {
    type: actionTypes.TRIGGER_NEXT_STEP,
    val: {
      currentStep: step,
      nextStep: doc,
    },
  };
};

export const onChartSelected = (chart) => {
  const nextStep = CHART_SELECTED_MESSAGE;
  return {
    type: actionTypes.CHART_SELECTED,
    val: {
      nextStep: nextStep,
      chart: chart,
    },
  };
};

export const onChartUnselected = () => {
  const nextStep = SELECT_CHART_MESSAGE;
  return {
    type: actionTypes.CHART_UNSELECTED,
    val: nextStep,
  };
};

export const optionSelected = (option) => {
  let nextStep;
  nextStep = {
    ...option,
    message: option.label,
    extractedMessage: option.extractedMessage,
    user: true,
    apiValue: option.apiValue,
    timeStamp: new Date(),
    messageOption: option.id=='o13-ai-options'? option.message:''
  };
  delete nextStep.isOption;
  return {
    type: actionTypes.OPTION_SELECTED,
    val: nextStep,
  };
};

export const toolkitSelected = (nextStep) => {
  return {
    type: actionTypes.RECOMMENDED_TOOLKIT_OPTION_SELECTED,
    val: nextStep,
  };
};

export const unselectChartWithNoFeedback = () => {
  return {
    type: actionTypes.UNSELECT_CHART_WITH_NO_FEEDBACK,
    val: null,
  };
};

export const fetchRecommendedTools = (kpiCode) => {
  const mapper = find(toolkitRecommender, { code: kpiCode });
  if (mapper) {
    const options = mapper.toolkits.map((tool, i) => {
      tool.id = `rt${i}`;
      tool.label = tool.name;
      tool.isOption = true;
      tool.url = tool.url;
      tool.kpi = kpiCode;
      tool.trigger = "RECOMMENDED_TOOLKIT_SELECTED";
      tool.subcategory = tool.subcategory;
      return tool;
    });
    const nextStep = { id: "rt", options: options };
    return {
      type: actionTypes.FETCH_RECOMMENDED_TOOLS,
      val: nextStep,
    };
  } else {
    const nextStep = {
      id: "rt",
      options: [
        {
          id: `rt0`,
          label: "No Toolkits",
          isOption: true,
          url: "#",
          trigger: "RECOMMENDED_TOOLKIT_SELECTED",
        },
      ],
    };
    return {
      type: actionTypes.FETCH_RECOMMENDED_TOOLS,
      val: nextStep,
    };
  }
};

export const selectKpiForChart = (selectedChart) => {
  const kpiNames = selectedChart.kpiData.map((kpi) => {
    // console.log(kpi);
    return kpi.kpiId.name;
  });
  // const options = kpiNames.map((name,i) => {
  //   const option = {};
  //   option.id = `st${i}`;
  //   option.label=name;
  //   option.category = name;
  // option.isOption = true;
  // option.trigger = `21`;
  //   return option;
  // });

  const result = [];
  const map = new Map();
  for (const item of kpiNames) {
    console.log("item--", item);
    if (!map.has(item)) {
      map.set(item, true); // set any value to Map
      result.push({
        id: item,
        label: item,
        isOption: true,
        trigger: `21`,
      });
    }
  }
  console.log(result);
  // const options = kpiNames.filter(distinct)
  // map((name,i) => {
  //   const option = {};
  //   option.id = `st${i}`;
  //   option.label=name;
  //   option.category = name;
  //   option.isOption = true;
  //   option.trigger = `21`;
  //   return option;
  // });
  const nextStep = { id: `st1`, options: result };
  return {
    type: actionTypes.SELECT_KPI_FOR_CHART,
    val: nextStep,
  };
};

export const triggerStep = (step) => {
  return {
    type: actionTypes.SET_CURRENT_STEP,
    val: step,
  };
};

export const updateStep = (step) => {
  return {
    type: actionTypes.DANI_UPDATE_STEP,
    val: step,
  };
};

const handleKeyWordMultipleCalls = (
  dispatch,
  keyword,
  searchType,
  messages,
  systemType,
  isShowMore,
  isDownloadableResponse,
  step
) => {
  const tokenAllowed = 2500;
  const tokenChunkSize = 4 * tokenAllowed;
  const splitted_array = [];
  for (let i = 0; i < keyword.length; i += tokenChunkSize) {
    splitted_array.push(keyword.slice(i, i + tokenChunkSize));
  }

  let part = 1;

  let consolidatedResult = {
    usage: {},
    searchResults: [
      {
        description: "CONSOLIDATE_RESPONSE",
        isClicked: false,
        query: "",
        title: "",
      },
    ],
  };

  const uploadAndGetResponse = (text) => {
    const request = axios.post(url.chatHelp, {
      content: standardizeSearchQuery(text),
      step: step.id,
      messages: [],
      systemType,
    });

    request.then(({ data }) => {
      const payload = data.data;
      part++;
      consolidatedResult["usage"] = payload.usage;
      const resText = payload.searchResults[0].description;
      let splitter = "";
      let text = "";
      let changesMade = "";

      if (resText.indexOf("Changes Made:") > -1) {
        splitter = "Changes Made:";
      } else if (resText.indexOf("Changes made:") > -1) {
        splitter = "Changes made:";
      } else if (resText.indexOf("Changes Made") > -1) {
        splitter = "Changes Made";
      } else if (resText.indexOf("Changes made") > -1) {
        splitter = "Changes made";
      } else if (resText.indexOf("Feedback:") > -1) {
        splitter = "Feedback:";
      }

      if (splitter) {
        text = "<br/>" + resText.split(splitter)[0];
        changesMade =
          splitter === "Feedback:"
            ? `<br><b>Feedback</b></br>` + resText.split(splitter)[1]
            : "<br/>" + resText.split(splitter)[1];
      } else {
        text = resText;
        changesMade = "";
      }
      dispatch({
        type: actionTypes.DANI_SET_FILE_MULTIPART_RESPONSE,
        payload: {
          text,
          changesMade,
        },
      });

      splitted_array.shift();
      if (splitted_array.length === 0) {
        // for (const obj of allResponses) {
        //   consolidatedResult["usage"] = obj.usage;
        //   consolidatedResult.searchResults[0].description +=
        //     obj.searchResults[0].description;
        // }
        setTimeout(() => {
          let { searchResults, usage } = consolidatedResult;
          const id = Math.floor(Math.random() * 1000 + 1);
          const resultStep = [];

          resultStep.push(
            Object.assign(
              {},
              { id: id },
              searchResults[0],
              { searchResults: true },
              {
                trigger: "file_upload_dani_response",
              },
              { end: true },
              { isDownloadableResponse: isDownloadableResponse },
              { timeStamp: new Date() },
              { questionAsked: keyword },
              { selectedOptionId: step.id }
            )
          );

          dispatch({
            type: actionTypes.SEARCH_RESULTS_FETCHED,
            val: {
              nextStep: resultStep,
              searchedTerm: keyword,
              searchResults: searchResults,
              page: 0,
              latestStepId: id,
            },
          });
        }, 500);

        return;
      } else {
        dispatch(triggerStep({ message: `Uploading part - ${part}` }));
        uploadAndGetResponse(splitted_array[0]);
      }
    });

    request.catch((err) => {
      console.log(err);

      const loadingStep = Object.assign(
        {},
        {
          id: "",
          message: `Im sorry, can you ask that question again or in a different way?`,
          answer: true,
          trigger: "15",
          end: true,
        }
      );
      dispatch(triggerStep(loadingStep));
      dispatch(triggerNextStep(loadingStep));
    });
  };

  dispatch(triggerStep({ message: `Uploading part - ${part}` }));
  uploadAndGetResponse(splitted_array[0]);
};
export const fetchSearchResults = (
  keyword,
  searchType,
  messages,
  systemType,
  isShowMore,
  isDownloadableResponse,
  step,
  currentChatId,
  isOpenAPI,
  default_language
) => {
  /**
   * Bing uses '+' instead of space.
   * also we found that 'and' is giving better results then '&'
   * Also, is someone searches for DEI bing is not giving correct results.
   * that is why, replacing DEI with D & I.
   */
  const upload_options = UPLOAD_PDF_OPTIONS_AFTER_RESPONSE.options.map(
    (e) => e.id
  );

  const getHistoryMessagesForCurrentChat = () => {
    let currentContext = [];
    for (const msg of messages) {
      if (currentChatId == msg.currentChatId) {
        currentContext.push(msg);
      }
    }
    return currentContext;
  };
  console.log(upload_options, step.id);
  return (dispatch) => {
    let request;
    const currentContextMessages = getHistoryMessagesForCurrentChat();
    const limitPromptMessages =
      upload_options.indexOf(step.id) == -1
        ? reduceDaniHistoryMessages(
            [...currentContextMessages.filter((x) => !x.isUploadOp)],
            keyword
          )
        : [];

    const keyWordTokens = keyword.length / 4;

    if (keyWordTokens > 3000 && isDownloadableResponse) {
      return handleKeyWordMultipleCalls(
        dispatch,
        keyword,
        searchType,
        messages,
        systemType,
        isShowMore,
        isDownloadableResponse,
        step
      );
    }

    if (
      searchType === chatQuerySearchTypes.SCRAPE ||
      searchType === chatQuerySearchTypes.AI_SINGLE_QUESTION
    ) {
      request = axios.get(url.getSearchResults, {
        params: {
          query: `${keyword
            .replace(/ /g, "+")
            .replace("DEI", "D & I")
            .replace("D&I", "D & I")
            .replace(
              /&/g,
              "and"
            )}+ inbody:diversity+and+inclusion+at+workplace`,
        },
      });
    } else if (searchType === chatQuerySearchTypes.AI_SINGLE_QUESTION) {
      request = axios.post(url.chatHelp, {
        content: standardizeSearchQuery(keyword),
        step: step.id,
        messages: limitPromptMessages.map((x) => ({
          role: x.role,
          content: x.content,
        })),
        systemType,
        isOpenAPI,
        default_language
      });
    }
    dispatch({
      type: actionTypes.FETCH_RESULTS_LOADING,
      payload: true,
    });

    request.then(({ data }) => {
      console.log("data ---- ", data);
      dispatch({
        type: actionTypes.FETCH_RESULTS_LOADING,
        payload: false,
      });
      const payload = data.data;
      const { searchResults=[], usage } = payload;
      let sResults = searchResults || [];
     
      if (sResults.length === 0) {
        const nextStep = {
          id: "20",
          message:
            "I'm sorry, but no results were found. Maybe I can help you with a different question?",
          trigger: "15",
          answer: true,
          end: true,
        };
        dispatch({
          type: actionTypes.SEARCH_RESULTS_FETCHED,
          val: {
            nextStep: nextStep,
          },
        });
      } else {
        if (searchType === chatQuerySearchTypes.SCRAPE) {
          const filteredSearchResults = searchResults.filter((x) => {
            if (x.url && x.url.length) {
              return true;
            }
            // else if (x.description && x.description.length) {
            //   return true;
            // }
            else {
              return false;
            }
          });
          const id = Math.floor(Math.random() * 1000 + 1);
          const resultStep = [];

          if (filteredSearchResults.length > 0) {
            const resultObj = {
              description:"",
              title:"",
              isClicked:"",
              url:""
            }

            let listResults = `<ol>`

            for (const result of filteredSearchResults) {
                listResults += `
                <li>
                     <div>
                         <a href="${result.url}" target="_blank">${result.title}</a>
                     </div>
                     <div>
                        ${result.description}
                     </div>
                </li>
                `
            }

            listResults += "</ol>";

            resultObj["description"] = listResults
            resultStep.push(
              Object.assign(
                {},
                { id: id },
                resultObj,
                { searchResults: true },
                { trigger: "15" }
              )
            );
          } else {
            const nextStep = {
              id: id,
              message:
                "I'm sorry, but no results were found. Maybe I can help you with a different question?",
              trigger: "15",
              answer: true,
              end: true,
            };

            resultStep.push(nextStep);
          }

          dispatch({
            type: actionTypes.SEARCH_RESULTS_FETCHED,
            val: {
              nextStep: resultStep,
              searchedTerm: keyword,
              searchResults: filteredSearchResults,
              page: 0,
              latestStepId: id,
            },
          });
        } else if (
          [chatQuerySearchTypes.AI_SINGLE_QUESTION].includes(searchType)
        ) {
          let filteredSearchResults = [...searchResults];

          if (searchType === chatQuerySearchTypes.SCRAPE) {
            filteredSearchResults = searchResults.filter(
              (r) => r.url && r.url.length > 0
            );
          }
          const isUploadOp = upload_options.indexOf(step.id) > -1;
          if (searchType === chatQuerySearchTypes.AI_SINGLE_QUESTION) {
            dispatch({
              type: actionTypes.ADD_DANI_ASSISTANT_SESSION_MESSAGES,
              payload: [
                {
                  role: "user",
                  content: isUploadOp ? keyword.substring(0, 200) : keyword,
                  isUploadOp: isUploadOp,
                  currentChatId: currentChatId,
                },
                {
                  currentChatId: currentChatId,
                  role: "assistant",
                  content: isUploadOp
                    ? filteredSearchResults[0].description.substring(0, 200)
                    : filteredSearchResults[0].description,
                  usage,
                  isUploadOp: isUploadOp,
                },
              ],
            });
          }
          const id = Math.floor(Math.random() * 1000 + 1);
          const resultStep = [];

          resultStep.push(
            Object.assign(
              {},
              { id: id },
              filteredSearchResults[0],
              { searchResults: true },
              {
                trigger: isDownloadableResponse ? "36" : "15",
              },
              { end: true },
              { isDownloadableResponse: isDownloadableResponse },
              { timeStamp: new Date() },
              { questionAsked: keyword }
            )
          );

          dispatch({
            type: actionTypes.SEARCH_RESULTS_FETCHED,
            val: {
              nextStep: resultStep,
              searchedTerm: keyword,
              searchResults: filteredSearchResults,
              page: 0,
              latestStepId: id,
            },
          });
        }
      }
    });

    request.catch((err) => {
      dispatch({
        type: actionTypes.FETCH_RESULTS_LOADING,
        payload: false,
      });

      if (isDownloadableResponse) {
        const loadingStep = Object.assign(
          {},
          {
            id: "",
            message: `Im sorry, can you ask that question again or in a different way? <br> Please select upload option again to procced or Keep chatting.`,
            answer: true,
            trigger: "file_upload_dani_response",
            end: true,
          }
        );
        dispatch(triggerStep(loadingStep));
        // dispatch(triggerNextStep(loadingStep));
      } else {
        const loadingStep = Object.assign(
          {},
          {
            id: "",
            message: `Im sorry, can you ask that question again or in a different way?`,
            answer: true,
            trigger: "15",
            end: true,
          }
        );
        dispatch(triggerStep(loadingStep));
        dispatch(triggerNextStep(loadingStep));
      }
    });
  };
};

export const fetchMoreSearchResults = (
  searchResults,
  page,
  searchType,
  messages,
  systemType
) => {
  const id = Math.floor(Math.random() * 1000 + 1);
  const resultStep = [];

  return (dispatch) => {
    if (searchType === chatQuerySearchTypes.AI_SINGLE_QUESTION) {
      // dispatch({
      //   type: actionTypes.ADD_DANI_ASSISTANT_SESSION_MESSAGES,
      //   payload: [
      //     {
      //       role: "assistant",
      //       content: searchResults[page].description,
      //     },
      //   ],
      // });
    }
    const isOddAvailable = searchResults[page];
    if (isOddAvailable) {
      resultStep.push(
        Object.assign(
          {},
          { id: id },
          searchResults[page],
          { searchResults: true },
          { trigger: systemType === "talk" ? "15" : "33" }
        )
      );
    } else {
      const nextStep = {
        id: "20",
        message:
          "I'm sorry, but no results were found. Maybe I can help you with a different question?",
        trigger: "15",
        end: true,
      };
      dispatch({
        type: actionTypes.SEARCH_RESULTS_FETCHED,
        val: {
          searchResults: [],
          nextStep: nextStep,
        },
      });
    }

    dispatch({
      type: actionTypes.MORE_SEARCH_RESULTS_FETCHED,
      val: {
        nextStep: resultStep,
        page: page,
      },
    });
  };
};

export const onToolkitSelected = () => {
  const nextStep = TOOLKIT_SELECTED_STEP;
  // console.log("triggering next step..");
  return {
    type: actionTypes.TOOLKIT_SELECTED,
    val: nextStep,
  };
};

export const drillDownChart = () => {
  return {
    type: actionTypes.DRILLDOWN_CHART,
    val: null,
  };
};

export const closeDrillDownModal = () => {
  const nextStep = CHART_SELECTED_MESSAGE;
  return {
    type: actionTypes.CLOSE_DRILLDOWN_MODAL,
    val: nextStep,
  };
};

export const minimizeDani = () => {
  return {
    type: actionTypes.MINIMIZE_DANI,
    val: null,
  };
};

export const maximizeDani = () => {
  return {
    type: actionTypes.MAXIMIZE_DANI,
    val: null,
  };
};

export const setDaniResponseLoading = (flag) => {
  return {
    type: actionTypes.FETCH_RESULTS_LOADING,
    payload: flag,
  };
};

export const addDaniHistoryChats = (data) => {
  return {
    type: actionTypes.ADD_CHATS_TO_HISTORY,
    payload: data,
  };
};
export const setDaniLatestStepId = (data) => {
  return {
    type: actionTypes.SET_LATEST_STEP_ID,
    payload: data,
  };
};
export const setDaniCurrentChatId = (data) => {
  return {
    type: actionTypes.SET_DANI_CURRENT_CHAT_ID,
    payload: data,
  };
};
export const setDaniExtractedText = (data) => {
  return {
    type: actionTypes.SET_DANI_EXTRACTED_TEXT,
    payload: data,
  };
};

export const deleteDaniHistoryChat = (data) => {
  return {
    type: actionTypes.DELETE_DANI_HISTORY_CHAT,
    payload: data,
  };
};

export const resetDaniFileMultiPartData = (data) => {
  return {
    type: actionTypes.DANI_RESET_FILE_MULTIPART_RESPONSE,
    payload: {},
  };
};
export const daniEngageActionClick = (data) => {
  return {
    type: actionTypes.DANI_SET_ENGAGE_ACTION_CLICK,
    payload: data,
  };
};
